export default __webpack_public_path__ + "static/media/1993.d144ebb6.png";